//Global External Imports
import React, {useEffect, useState, Fragment} from "react";
import {Grid, Card, Box } from '@mui/material'
import {DragDropContext} from 'react-beautiful-dnd';

//Global Internal Imports

//Child Imports
import Liste from "./Liste";
import { useTranslation } from 'react-i18next';

function FormularAufbau(props) {
  const { t } = useTranslation();
  //Standardfelder
  const {formular, felder, stammfelder, listeFormular, lStamm, ChangeFormular, FeldBearbeiten, CopyFeld, DelFeld, NewSfeld} = props;

  //Arbeitsfelder
  const [listeStamm,setListeStamm]=useState([])
  const [feldtyp,setFeldtyp]=useState(null)
  //uesEffects
  useEffect(() => {
    setListeStamm(lStamm)
    // eslint-disable-next-line
  }, [lStamm])

  //Standardfunktionen

  //Arbeitsfunktionen
  function onDragStart(start){
    if (start.draggableId.substr(0,1)==="S"){
      setFeldtyp("S")
    } else {
      setFeldtyp(felder[formular][start.draggableId].art)
    }
  }

    function onDragEnd(result){
      setFeldtyp(null)
      const {source, destination}=result;
      if (!destination){
        return
      }

      if (source.droppableId===destination.droppbaleId&&source.index===destination.index){
        return
      }

      if (source.droppableId==="S"){
        const newArray=Array.from(listeStamm);
        if (destination.droppableId==="S"){
          newArray.splice(source.index,1);
          newArray.splice(destination.index,0,listeStamm[source.index]);
          setListeStamm(newArray)
        }
        if (destination.droppableId==="F"){
          const newArray2=Array.from(listeFormular);
          newArray.splice(source.index,1);
          newArray2.splice(destination.index,0,listeStamm[source.index]);
          setListeStamm(newArray)
          ChangeFormular(newArray2)
          NewSfeld(stammfelder[listeStamm[source.index]].key,stammfelder[listeStamm[source.index]].name)
        }
      }

      if (source.droppableId==="F"){
        const newArray=Array.from(listeFormular);
        if (destination.droppableId==="F"){
          newArray.splice(source.index,1);
          newArray.splice(destination.index,0,listeFormular[source.index]);
          ChangeFormular(newArray)
        }
        if (destination.droppableId==="S"){
          const newArray2=Array.from(listeStamm);
          newArray.splice(source.index,1);
          newArray2.splice(destination.index,0,listeFormular[source.index]);
          ChangeFormular(newArray)
          setListeStamm(newArray2)
          DelFeld(felder[formular][listeFormular[source.index]],source.index)

        } 
      }
    }

  function FeldOnClick(arg,feld,liste,index){
    if (arg.ctrlKey){
      if (feld.art==="S"){
        ShiftFelder(feld,liste,index)
      } else {
        //DelFeld(feld,index)
      }
    } else if (arg.altKey){
      if (liste!=="F") return
      CopyFeld(feld,index)
    } else if (arg.shiftKey){
      if (liste!=="F") return
      if (feld.art==="S") {
        ShiftFelder(feld,liste,index)
      } else {
        DelFeld(feld,index)
      }
    } else {
      FeldBearbeiten(feld)
    }
  }

  function ShiftFelder(feld,liste,index){
    var result={}
    var source={}
    var destination={}
    source.droppableId=liste;
    source.index=index;
    if (liste===feld.art){
      destination.droppableId="F"
    } else {
      destination.droppableId=feld.art
    }
    if (destination.droppableId==="F"){
      destination.index=listeFormular.length
    }
    result.source=source;
    result.destination=destination;
    onDragEnd(result)  
  }

  //Renderfunktionen  
  
  function renderListen(){
    if (!felder[formular]) return

    const tmpListeFormular=listeFormular.filter((item)=>{
        if (felder[formular][item]) return true;
        if (stammfelder[item]) return true;
        return false;
      }).map((key)=>{
      if (key.substr(0,1)==="S"&&!felder[formular][key]){
        return(stammfelder[key])    
      } else {
        return(felder[formular][key])    
      }
    })   
    const tmpListeStamm=listeStamm.filter((item)=>stammfelder[item]).map((key)=>{
      return(stammfelder[key])    
    })
      return(
        <Fragment>
        <Grid item xs={12} md={8}>
          <Card>
          <Box p={3}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12} md={10}>
              <Liste id="F" name={t("Formularaufbau")} felder={tmpListeFormular} dropDisabled={false} onClick={FeldOnClick}/>
            </Grid>
          </Grid>
          </Box>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <Box p={3}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12} md={10}>
              <Liste id="S" name={t("Stammfelder")} felder={tmpListeStamm} dropDisabled={feldtyp!=="S"} onClick={FeldOnClick}/>
            </Grid>
          </Grid>
          </Box>
          </Card>
        </Grid>
        </Fragment>
      )
  }

  //Rückgabe
  return(
    <Box p={3}>
      <DragDropContext
        onDragStart={(s)=>onDragStart(s)}
        onDragEnd={(r)=>onDragEnd(r)}
      >
        <Grid container justifyContent="flex-start" spacing={5}>
          {renderListen()}
        </Grid>
      </DragDropContext>
      
    </Box>
  )

}

export default FormularAufbau;
